import { Money } from '../lib';

export class AcceptedMoney {
  money: Money[] = [];
  enabled = false;
}
